import React from 'react';

class Image extends React.Component {
    constructor(props) {
        super(props);
    }


    render() {
        return (
            <section className="section">
                <div className="main-container">
                    <div className="inner-container">
                        <figure className="vhContainer">
                            <img src={this.props.imgsrc} alt="ProjctTitle" title="ProjctTitle"/>
                        </figure>
                    </div>
                </div>
            </section>
        );
    }
}
export default Image;



// WEBPACK FOOTER //
// ./src/components/Projects/Marmalade/Image.js